import MessageBroker from '@Services/MessageBroker';
import RequestUrls from '@Constants/RequestUrlsConstants';

// starts with 0
const getBackOffInterval = (count) => {
  const initialIntervals = [100, 300];
  const intervalsStep = 500;
  const maxInterval = 30000;
  let interval;

  if (initialIntervals[count]) {
    interval = initialIntervals[count];
  } else {
    interval = (count - initialIntervals.length + 1) * intervalsStep;
  }

  return Math.min(interval, maxInterval);
};

const isHealthCheckResponseOk = (response) => {
  const { 'A&E_SERVICE': aeResponse, XML_SESSION_HC_FORWARD: xmlResponse } = response;
  const isStatusTrue = (resp) => resp && (resp.Status === true || resp.Status === 'true');
  return isStatusTrue(aeResponse) && isStatusTrue(xmlResponse);
};

// eslint-disable-next-line import/prefer-default-export
export const initHealthCheckRequester = () => {
  let stopHealthCheck = false;
  let healthCheckTimeout;

  const getXmlAndAeHealthCheck = (count = 0) => {
    if (stopHealthCheck) {
      return;
    }

    // back-off timeout
    healthCheckTimeout = setTimeout(() => {
      MessageBroker.send(RequestUrls.xmlAndAeHealthCheck, {}, { cache: false })
        .then((response) => {
          // if not ok - throw error, it will be handled properly in catch block
          if (!isHealthCheckResponseOk(response)) {
            return Promise.reject(response);
          }
          return window.history.back();
        })
        .catch((e) => {
          Logger.error(e);
          // subsequent call with increasing interval
          getXmlAndAeHealthCheck(count + 1);
        });
    }, getBackOffInterval(count));
  };

  // first request
  getXmlAndAeHealthCheck();

  return () => {
    stopHealthCheck = true;
    if (healthCheckTimeout) {
      clearTimeout(healthCheckTimeout);
    }
  };
};
